module.exports = __webpack_public_path__ + "img/navigation-menu-1.0443622f.svg";